var $ = require('jquery')
  , urlUtils = require('@173js/url')

module.exports = function whenQueryEqual(queryName, beEqualValue) {
  var dfd = new $.Deferred()
    , queryValue = urlUtils.getURLParameter(queryName)

  dfd[queryValue === beEqualValue ? 'resolve': 'reject']()

  return dfd.promise()
}
